import Vue from 'vue'
import VueRouter from 'vue-router'
import experimentRouter from './modules/experiment'
import experimentationRouter from './modules/experimentation'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    redirect: '/experiment',
    component: () => import('../layout/index.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/simulation',
        name: 'Simulation',
        component: () => import('../views/simulation/index.vue'),
        meta: {
          title: '仿真实验'
        }
      },
      {
        path: '/architecture',
        name: 'Architecture',
        component: () => import('../views/architecture/index.vue'),
        meta: {
          title: '建筑作品'
        }
      },
      {
        path: '/introduction',
        name: 'Introduction',
        component: () => import('../views/introduction/index.vue'),
        meta: {
          title: '中心概况'
        }
      },
      // {
      //   path: '/team',
      //   name: 'Team',
      //   component: () => import('../views/introduction/index.vue'),
      //   meta: {
      //     title: '师资队伍'
      //   }
      // },
      // {
      //   path: '/partner',
      //   name: 'Partner',
      //   component: () => import('../views/introduction/index.vue'),
      //   meta: {
      //     title: '校企合作'
      //   }
      // },
      // {
      //   path: '/achievement',
      //   name: 'Achievement',
      //   component: () => import('../views/introduction/index.vue'),
      //   meta: {
      //     title: '教学成果'
      //   }
      // },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        redirect: '/personalCenter/experimentalScore',
        component: () => import('../views/personalCenter/personalCenter.vue'),
        meta: {
          title: '个人中心'
        },
        children: [
          {
            path: 'experimentalScore',
            name: 'experimentalScore',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/experimentalScore.vue'),
            meta: {
              title: '实验成绩'
            }
          },
          {
            path: 'experimentalReport',
            name: 'experimentalReport',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/experimentalReport.vue'),
            meta: {
              title: '实验报告'
            }
          },
          {
            path: 'myWork',
            name: 'myWork',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/myWork.vue'),
            meta: {
              title: '我的作品'
            }
          },
          {
            path: 'learned',
            name: 'learned',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/learned.vue'),
            meta: {
              title: '已学课程'
            }
          },
          {
            path: 'myQuestion',
            name: 'myQuestion',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/myQuestion.vue'),
            meta: {
              title: '我的问题'
            }
          },
          {
            path: 'myInfo',
            name: 'myInfo',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/myInfo.vue'),
            meta: {
              title: '个人信息'
            }
          },
          {
            path: 'accountSecurity',
            name: 'accountSecurity',
            component: () => import('../views/personalCenter/showUser_all_Info_Container/nav_right_show/accountSecurity.vue'),
            meta: {
              title: '账号安全'
            }
          },
        ]
      }
    ]
  },
  ...experimentRouter,
  ...experimentationRouter,
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/user/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/user/register.vue'),
    meta: {
      title: '注册'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router
